import { MenuItem, TextField } from "@mui/material";
import { Controller } from "react-hook-form";
import { useStyleSelectList } from "../../../services/productsService";

const disabledInputSx = {
    "& .MuiInputBase-input.Mui-disabled": {
        WebkitTextFillColor: "#010a1a",
    },
};

export const ProductStyleDropdown = (props) => {
    const { control, fieldName, disabled = false, investment} = props;

    const { data, isLoading } = useStyleSelectList(new URLSearchParams({investment: investment}));

    if (!data || isLoading) {
        return [];
    }

    return (
        <Controller
            name={fieldName}
            control={control}
            render={({ field }) => (
                <TextField
                    {...field}
                    value={field.value}
                    select
                    fullWidth
                    disabled={disabled}
                    sx={disabled ? disabledInputSx : undefined}
                >
                    {data?.map((style) => (
                        <MenuItem key={style.id} value={style.id}>
                            {style.style_name}
                        </MenuItem>
                    ))}
                </TextField>
            )}
        />
    );
};
